// 小里站
export function getImgParams(projectId) {
  let address = null
  let scale = [1.03, 1.03, 1.03]
  let aspect = 0.56
  let rotationZ = 0
  let positionZ = 640
  let positionX = 150
  switch (projectId) {
    case '1785989790454255618':
      address = '/static/img/3biao-map.png'
      scale = [1.1, 1.1, 1.1]
      aspect = 0.35
      rotationZ = 0.3
      positionZ = -450
      positionX = -100
      break
    case '1770080775527694338':
      address = '/static/img/4biao-map.jpg'
      scale = [1.35, 1.35, 1.35]
      aspect = 0.59
      rotationZ = 0.3
      break
    case '1829316449950466049':
      address = '/static/img/6biao-map.png'
      scale = [1.7, 1.7, 1.7]
      aspect = 0.7
      rotationZ = 0.3
      break
    case '1871880073338949633':
      address = '/static/img/qianTang-map.png'
      scale = [0.8, 0.8, 0.8]
      aspect = 1.22
      positionZ = -650
      positionX = -500
      rotationZ = 0.1
      break
    default:
      break
  }
  return { address, scale, aspect, rotationZ, positionZ, positionX }
}

export function getNewCoordinate({ projectCraneId, x, y }) {
  let newX = x
  let newY = y
  switch (projectCraneId) {
    // 小里站
    // 18#
    case '1766047418460606465':
      newY += 20
      newX -= 8
      break
    // 16#
    case '1752519525192679426':
      newY += 18
      newX -= 6
      break
    // 17#
    case '1752520281605279746':
      newY += 18
      newX -= 10
      break
    // 14#
    case '1761013116464173057':
      newY += 12
      newX -= 4
      break
    // 15#
    case '1761012323048656898':
      newY += 13
      newX -= 7
      break
    // 12#
    case '1770687066898235394':
      newY += 8
      newX -= 6
      break
    // 13#
    case '1761013867799552001':
      newY += 8
      newX -= 6
      break
    // 10#
    case '1766049181028782081':
      newY += 9
      newX -= 6
      break
    // 11#
    case '1766047781897048065':
      newY += 8
      newX -= 7
      break
    // 8#
    case '1752520411360268289':
      newY += 8
      newX -= 6
      break
    // 9#
    case '1766048142091292673':
      newY += 7
      newX -= 6
      break
    // 7#
    case '1752520346684100609':
      newY += 3
      newX -= 8
      break
    // 5#
    case '1781333425757085697':
      newX -= 8
      break
    // 3标
    // 10#
    case '1805568809350901761':
      newY -= 20
      newX += 20
      break
    // 1#
    case '1805195138455220225':
      newY -= 0
      newX += -10
      break
    // 2#
    case '1774789781295267841':
      newY -= 1
      newX -= 2
      break
    // 3#
    case '1774788835443535874':
      newY -= 14
      newX -= 6
      break
    // 6#
    case '1774412641623666690':
      newY -= 29
      newX -= 15
      break
    // 7#
    case '1776264231532027905':
      newY -= 25
      newX -= 30
      break
    // 4#
    case '1783827966495096833':
      newY -= 10
      newX -= 17
      break
    // 1#
    case '1774789496699158529':
      newY -= 5
      newX -= 35
      break
    // 8#
    case '1776390446134112257':
      newY -= 15
      newX -= 43
      break
    // 12#
    case '1770793910406279170':
      newY -= 4
      newX -= 57
      break
    // 13#
    case '1770794117084803073':
      newY -= 15
      newX -= 50
      break
    // 10#
    case '1770794010117468161':
      newY -= 20
      newX -= 70
      break
    // 11#
    case '1776259734348947458':
      newY -= 5
      newX -= 50
      break
    // 6标
    // 2#
    case '1829316561183154178':
      newY -= -60
      newX += 17
      break
    // 钱塘
    // 9#
    case '1871880073338949633':
      break;
    // 10#
    case '1871887395498156033':
      break;
    // 11#
    case '1871887356004589570':
      break;
    // 5#
    case '1871888735047237634':
      break;
    // 7#
    case '1871888660753530882':
      break;
    // 8#
    case '1871888589050273794':
      break;
    // 13#
    case '1871887254608920577':
      break;
    // 6#
    case '1871888704993419266':
      break;
    // 12#
    case '1871887299926745090':
      break;
    default:
      break
  }
  return { newX, newY }
}



// WEBPACK FOOTER //
// ./src/utils/bottomImgConfig.js